import React, { useState, useEffect } from 'react';
import styles from './RoleActionsModal.module.scss';
import { connect } from 'react-redux';
import Modal from '../../../layout/modal/Modal';
import { closeModal } from '../../../../redux/modals/action';
import { Chip, Grid } from '@mui/material';

const RoleActionsModal = (props) => {
	const {
		showModal,
		closeModal,
		roleIdOfChip,
		userIdOfChip,
		usersList,
		projectSelectedCode,
		projects,
		roles,
		accessibilities,
	} = props;

	const [userName, setUserName] = useState('');
	const [projectName, setProjectName] = useState('');
	const [role, setRole] = useState();

	useEffect(() => {
		if (userIdOfChip && usersList) {
			let filteredUsers = usersList.filter(
				(user) => user.id === userIdOfChip
			);
			if (filteredUsers.length > 0) {
				setUserName(filteredUsers[0].fullName);
			} else {
				setUserName('');
			}
		} else {
			setUserName('');
		}
	}, [userIdOfChip, usersList]);

	useEffect(() => {
		if (projectSelectedCode && projects) {
			let filteredProjects = projects.filter(
				(project) => project.id === projectSelectedCode
			);
			if (filteredProjects.length > 0) {
				setProjectName(filteredProjects[0].companyName);
			} else {
				setProjectName('');
			}
		} else {
			setProjectName('');
		}
	}, [projects, projectSelectedCode]);

	useEffect(() => {
		if (roleIdOfChip && roles) {
			let filteredRoles = roles.filter(
				(role) => role.roleId === roleIdOfChip
			);
			if (filteredRoles.length > 0) {
				setRole(filteredRoles[0]);
			} else {
				setRole();
			}
		} else {
			setRole();
		}
	}, [roleIdOfChip, roles]);

	const handleCloseModal = () => {
		closeModal('roleActions');
	};

	return (
		<div className={styles.role_actions}>
			<Modal
				show={showModal}
				close={handleCloseModal}
				title='User accessibility'
			>
				<div className={styles.role_actions_header}>
					<div className={styles.role_actions_header_left}>
						<h3 className={styles.user_name}>{userName}</h3>
						<Chip
							label={role?.roleName}
							className={styles.role_chip}
							color='primary'
							style={{
								backgroundColor: `${role?.roleColor}`,
							}}
						/>
					</div>
					<div className={styles.role_actions_header_right}>
						Project: {projectName}
					</div>
				</div>
				<div className={styles.role_actions_body}>
					{accessibilities.map((accessibility) => {
						let features = accessibility.features;
						let featuresArr = [];
						if (features) {
							featuresArr = Object.keys(features);
						}

						return (
							<div
								key={accessibility.moduleId}
								className={styles.module}
							>
								<h3 className={styles.module_name}>
									{accessibility.moduleName}
								</h3>
								<hr className={styles.divider} />
								<Grid container spacing={1}>
									{featuresArr.map((featureKey, index) => {
										let feature = features[featureKey];
										let actions = feature?.actions;

										if (actions) {
											return (
												<>
													{actions
														.filter((action) => {
															if (
																role &&
																role.roleAccessibilities &&
																role
																	.roleAccessibilities[
																	accessibility
																		.moduleId
																] &&
																role
																	.roleAccessibilities[
																	accessibility
																		.moduleId
																][featureKey]
															) {
																let actionArr =
																	role
																		.roleAccessibilities[
																		accessibility
																			.moduleId
																	][
																		featureKey
																	];
																return actionArr.includes(
																	action.actionId
																);
															} else {
																return false;
															}
														})
														.map(
															(action, index) => (
																<Grid
																	item
																	xs={6}
																	key={index}
																>
																	<p
																		className={
																			styles.action_name
																		}
																	>
																		{
																			action.actionTitle
																		}
																	</p>
																</Grid>
															)
														)}
												</>
											);
										}
									})}
								</Grid>
							</div>
						);
					})}
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	usersList: state.userManagement.users,
	projectSelectedCode: state.userManagement.projectSelectedCode,
	projects: state.userManagement.projects,
	roles: state.userManagement.roles,
	accessibilities: state.userManagement.accessibilities,
});

export default connect(mapStateToProps, {
	closeModal,
})(RoleActionsModal);
